import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// Component
const AppLoader = ({ color = "secondary", size, sx }) => {
    return (
        <Box 
            sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                width: "100%", 
                height: "100%",
                ...sx
            }}
        >
            <CircularProgress color={color} size={size} />
        </Box>
    );
};

export default AppLoader;
